<template>
  <AboutDirectSchool :title="title" :locations="locations" :people="people" />
</template>

<script>
import AboutDirectSchool from "@/components/AboutDirectSchool.vue";

export default {
  components: {
    AboutDirectSchool
  },
  data() {
    return {
      title: "南屯校區",
      locations: [
        {
          name: null,
          description: null,
          photo: require("../assets/nantun-photo.png"),
          address: "台中市南屯區河南路四段538號",
          phone: "04 2389-2887"
        }
      ],
      people: [
        {
          title: "國中部主任",
          photo: require("../assets/nantun-junior-high-school-director.png"),
          name: "黃哲瑜"
        },
        {
          title: "國小部主任",
          photo: require("../assets/nantun-elementary-school-director.png"),
          name: "陳癸宏"
        }
      ]
    };
  }
};
</script>

<style></style>
